import { useSelector } from 'react-redux';
import { ChannelInfo, ChannelKey } from '../app-types';
import { VideoCtvRedux } from '../store-types';

export const useKsNetwork = (
  network: ChannelKey | null | undefined = null,
):
  | ChannelInfo
  | { resourceId?: ChannelInfo['resourceId']; name?: ChannelInfo['name'] } => {
  const networks = useSelector(
    (state: VideoCtvRedux) => state.kitchenSink.data?.networks,
  );
  if (!network || !networks) return {};

  return networks[network] || {};
};

export const useNetworkName = (network: ChannelKey | null | undefined = null) => {
  const { name } = useKsNetwork(network);

  return name || '';
};

export const useNetworkResId = (network: ChannelKey | null | undefined = null) => {
  const { resourceId } = useKsNetwork(network);
  return resourceId || null;
};

export const useParamountPlusDisplayName = () => {
  const displayName = useSelector((state: VideoCtvRedux) => state.kitchenSink.data?.providers?.paramountplus?.displayName);

  return displayName;
};

export const useFW = () =>
  useSelector(
    (state: VideoCtvRedux) =>
      state.kitchenSink?.data?.config?.modules?.Freewheel?.enabled,
  );
